export const ESTIMATE_STATUSES = {
  NEW: 1,
  FINISH: 2,
};

export default {
  ESTIMATE_STATUSES,
};
